export const LOGIN_ACTION = 'LOGIN_ACTION';
export const LOADER = 'LOADER';
export const LOADER_MAIN_APP = 'LOADER_MAIN_APP';
export const TOKEN_SAVE = 'TOKEN_SAVE';
export const AUTH_ERROR = 'AUTH_ERROR';
export const SAVE_AUTH_RESPONSE = 'SAVE_AUTH_RESPONSE';
export const SAVE_CLIENT_DETAIL_INFO = 'SAVE_CLIENT_DETAIL_INFO';
export const GET_CLIENT_DETAIL_INFO = 'GET_CLIENT_DETAIL_INFO';
export const GET_CLIENTS_SIGN = 'GET_CLIENTS_SIGN'
export const SAVE_CLIENTS_SIGN = 'SAVE_CLIENTS_SIGN'
export const GET_CLIENT_CLINIC = 'GET_CLIENT_CLINIC'
export const SAVE_CLIENT_CLINIC = 'SAVE_CLIENT_CLINIC'
export const GET_CLIENT_DOC = 'GET_CLIENT_DOC'
export const SAVE_CLIENT_DOC = 'SAVE_CLIENT_DOC'
export const UPDATE_CLIENT_SIGN = 'UPDATE_CLIENT_SIGN'
export const SAVE_GENERICSUCCESS = 'SAVE_GENERICSUCCESS'
export const UPDATE_CLIENT_SIGN_PIN = 'UPDATE_CLIENT_SIGN_PIN'
export const SAVE_CLIENT_SIGN_PIN = 'SAVE_CLIENT_SIGN_PIN'
export const GET_SIGNED_DOC = 'GET_SIGNED_DOC'
export const SAVE_SIGNED_DOC = 'SAVE_SIGNED_DOC'
export const GET_PENDING_DOC = 'GET_PENDING_DOC'
export const SAVE_PENDING_DOC = 'SAVE_PENDING_DOC'
export const GET_DOCUMENT_URL = 'GET_DOCUMENT_URL'
export const SAVE_DOCUMENT_URL = 'SAVE_DOCUMENT_URL'
export const SAVE_SIGNED_DOC_RESP = 'SAVE_SIGNED_DOC_RESP'
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const SAVE_FORGOT_PASSWORD_RESPONSE = "SAVE_FORGOT_PASSWORD_RESPONSE"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const SAVE_CHANGE_PASSWORD_RESPONSE = "SAVE_CHANGE_PASSWORD_RESPONSE"
export const GET_CLIENT_DIAGNOSIS = "GET_CLIENT_DIAGNOSIS"
export const SAVE_CLIENT_DIAGNOSIS = "SAVE_CLIENT_DIAGNOSIS"
export const GET_CARE_PLAN = "GET_CARE_PLAN"
export const SAVE_CARE_PLAN = "SAVE_CARE_PLAN"
export const GET_CLIENT_APPOINTMENTS = "GET_CLIENT_APPOINTMENTS"
export const SAVE_CLIENT_APPOINTMENTS = "SAVE_CLIENT_APPOINTMENTS"
export const APPLY_CLIENT_SIGNATURE = "APPLY_CLIENT_SIGNATURE"
export const GET_CLIENT_TREATMENT_PLAN_SIGN = "GET_CLIENT_TREATMENT_PLAN_SIGN"
export const SAVE_CLIENT_TREATMENT_PLAN_SIGN = "SAVE_CLIENT_TREATMENT_PLAN_SIGN"
export const SET_APP_IS_IMPERSONATE = "SET_APP_IS_IMPERSONATE"
export const SET_MESSAGE_LOADING = "SET_MESSAGE_LOADING"
export const GET_MESSAGES = "GET_MESSAGES"
export const SAVE_MESSAGES = "SAVE_MESSAGES"
export const GET_UNREAD_MESSAGES = "GET_UNREAD_MESSAGES"
export const SAVE_UNREAD_MESSAGES = "SAVE_UNREAD_MESSAGES"
export const MARK_MESSAGE_READ = "MARK_MESSAGE_READ"
export const SET_MESSAGE_LIST_BACK = "SET_MESSAGE_LIST_BACK"
export const GET_LINKED_ACCOUNT_LIST = "GET_LINKED_ACCOUNT_LIST"
export const SET_LINKED_ACCOUNT_LIST = "SET_LINKED_ACCOUNT_LIST"
export const GET_PARENT_INFO = "GET_PARENT_INFO"
export const SAVE_PARENT_INFO = "SAVE_PARENT_INFO"
export const GET_CLIENT_QUESTIONNAIRES = "GET_CLIENT_QUESTIONNAIRES"
export const SAVE_CLIENT_QUESTIONNAIRES = "SAVE_CLIENT_QUESTIONNAIRES"
export const SAVE_CLIENT_PENDING_QUESTIONNAIRES = "SAVE_CLIENT_PENDING_QUESTIONNAIRES"
export const GET_CP_RESIGN_NOTIFICATION = "GET_CP_RESIGN_NOTIFICATION"
export const SAVE_CP_RESIGN_NOTIFICATION = "SAVE_CP_RESIGN_NOTIFICATION"
export const SAVE_DOC_IS_LOCKED = "SAVE_DOC_IS_LOCKED"
export const SAVE_IS_CLIENT_FILLABLE = "SAVE_IS_CLIENT_FILLABLE"
// 